import { Navigate, useRoutes } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { InactivePage } from 'components/ErrorsPage/InactivePage'

export const useBuildRoutes = () => {

  const { i18n:{language} } = useTranslation()
  
  return [
    {
      path: '/',
      element: <Navigate to={`/${language}/inactive`} replace />
    },
    {
      path: `/:lang/inactive`,
      element: <InactivePage />
    },
  ]
}

export const Views = () => useRoutes( useBuildRoutes() )